const EXCLUSION_TYPES = {
  UPC: 'upc',
};

export default EXCLUSION_TYPES;
